module.exports = __webpack_public_path__ + "img/horizontal_4_3_2.b154da0d.png";